"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.CmsHome = ({ integration }) => {
    if (!integration) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const tabs = [];
    tabs.push({
        id: 'subscribers-download',
        name: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "download", marginRight: true }),
            "Download")),
        to: `/integrations/${integration.id}/subscribers/download`,
    });
    tabs.push({
        id: 'subscribers-update',
        name: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "upload", marginRight: true }),
            "Update")),
        to: `/integrations/${integration.id}/subscribers/update`,
    });
    return (react_1.default.createElement(react_2.OsmosysSmallContainer, null,
        react_1.default.createElement(react_2.OsmosysDiv, { osysName: "CmsHome" },
            react_1.default.createElement("h3", { className: "text-center" }, integration.name))));
};
exports.CmsHomeLists = () => {
    return react_1.default.createElement(react_2.OsmosysDiv, { osysName: "CmsHomeLists" });
};
exports.CmsHomeOsmosysEmails = () => {
    return react_1.default.createElement(react_2.OsmosysDiv, { osysName: "CmsHomeOsmosysEmails" });
};
exports.EspConnectionStatusCard = () => {
    return react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EspConnectionStatusCard" });
};
//# sourceMappingURL=index.js.map